import { AnalogIn, AnalogOut, DigitalIn, DigitalOut } from "../../props/PropTypes"
import { CombiKaartType, HdwRackType, isCombiKaart, KaartType, MainboardType, SimpleKaartType, SysteemKaartType } from "./hdw-konfig-types"


export const SCXRack: HdwRackType = {
    bus: 'scx',
    slots: 10,
    label: 'Rack',
    karten: []
}

export const FastLinkRack: HdwRackType = {
    bus: 'fastlink',
    slots: 7,
    label: 'Veldstation',
    karten: [
        {
            metaId: "mainRackXtender",
            label: "XTender",
            bus: "fastlink",
            isExtension: true,
            maxDipSwitchBits: 4,
            takesRackSpace: true,
            hdwLayout: ["28V~", "28V~", "PE", "24Vm", "24Vm", "24V=", "24V=", "NUL", "NUL", "+5V",
                "NUL", "SHLD", "B", "A", "GND", "24V", "B", "A", "0V", "24V"
            ]
        }
    ]
}

export const SCXAIKart: SimpleKaartType = {
    metaId: "scxai",
    available: 32,
    bus: "scx",
    ioType: AnalogIn,
    label: "AI",
    reserved: 32,
    takesRackSpace: true,
    maxDipSwitchBits: 6,
    hdwLayout: ["AI1", "AI2", "0VAN",
        "AI3", "AI4", "AI5", "AI6", "0VAN", "AI7", "AI8", "AI9", "AI10", "0VAN",
        "AI11", "AI12", "AI13", "AI14", "0VAN", "AI15", "AI16", "AI17", "AI18", "0VAN",
        "AI19", "AI20", "AI21", "AI22", "0VAN", "AI23", "AI24", "AI25", "AI26", "0VAN",
        "AI27", "AI28", "AI29", "AI30", "0VAN", "AI31", "AI32"]
}

export const SCXAOKart: SimpleKaartType = {
    metaId: "scxao",
    available: 16,
    bus: "scx",
    ioType: AnalogOut,
    label: "AO",
    reserved: 16,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "AO1", "NUL", "AO2", "NUL", "AO3", "NUL", "AO4", "NUL", "n.c.", "NUL",
        "AO5", "NUL", "AO6", "NUL", "AO7", "NUL", "AO8", "NUL", "n.c.", "NUL",
        "AO9", "NUL", "AO10", "NUL", "AO11", "NUL", "AO12", "NUL", "n.c.", "NUL",
        "AO13", "NUL", "AO14", "NUL", "AO15", "NUL", "AO16", "NUL", "24Vm", "NUL"
    ]
}

export const SCXDIKart: SimpleKaartType = {
    metaId: "scxdi",
    available: 32,
    bus: "scx",
    ioType: DigitalIn,
    label: "DI",
    reserved: 32,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "DI1", "DI2", "DI3", "DI4", "DI5", "DI6", "DI7", "DI8", "NUL", "NUL",
        "DI9", "DI10", "DI11", "DI12", "DI13", "DI14", "DI15", "DI16", "NUL", "NUL",
        "DI17", "DI18", "DI19", "DI20", "DI21", "DI22", "DI23", "DI24", "NUL", "NUL",
        "DI25", "DI26", "DI27", "DI28", "DI29", "DI30", "DI31", "DI32", "NUL", "NUL"
    ]
}

export const SCXDOKart: SimpleKaartType = {
    metaId: "scxdo",
    available: 32,
    bus: "scx",
    ioType: DigitalOut,
    label: "DO",
    reserved: 32,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "DO1", "DO2", "DO3", "DO4", "DO5", "DO6", "DO7", "DO8", "24V", "NUL",
        "DO9", "DO10", "DO11", "DO12", "DO13", "DO14", "DO15", "DO16", "24V", "NUL",
        "DO17", "DO18", "DO19", "DO20", "DO21", "DO22", "DO23", "DO24", "24V", "NUL",
        "DO25", "DO26", "DO27", "DO28", "DO29", "DO30", "DO31", "DO32", "24V", "NUL"
    ]
}

export const SCXROKart: SimpleKaartType = {
    metaId: "scxro",
    available: 32,
    bus: "scx",
    ioType: DigitalOut,
    label: "RO",
    reserved: 32,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "DO1", "DO2", "DO3", "DO4", "DO5", "DO6", "DO7", "DO8", "G1/8", "NUL",
        "DO9", "DO10", "DO11", "DO12", "DO13", "DO14", "DO15", "DO16", "G9/16", "NUL",
        "DO17", "DO18", "DO19", "DO20", "DO21", "DO22", "DO23", "DO24", "G17/32", "NUL",
        "DO25", "DO26", "DO27", "DO28", "DO29", "DO30", "DO31", "DO32", "24Vm", "NUL"
    ]
}

export const FastLinkAIKart: SimpleKaartType = {
    metaId: "fastlinkai",
    available: 16,
    bus: "fastlink",
    ioType: AnalogIn,
    label: "Fastlink AI",
    reserved: 16,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "AI1", "AI2", "AI3", "AI4", "AI5", "AI6", "AI7", "AI8",
        "AI9", "AI10", "AI11", "AI12", "AI13", "AI14", "AI15", "AI16",
        "0VA", "0VA", "24V"
    ]
}

export const FastlinkAOKart: SimpleKaartType = {
    metaId: "fastlinkao",
    available: 8,
    bus: "fastlink",
    ioType: AnalogOut,
    label: "Fastlink AO",
    reserved: 8,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "AO1", "NUL", "AO2", "NUL", "AO3", "NUL", "AO4", "NUL", "n.c.", "NUL",
        "AO5", "NUL", "AO6", "NUL", "AO7", "NUL", "AO8", "NUL", "24V=", "NUL"
    ]
}

export const FastlinkDIKart: SimpleKaartType = {
    metaId: "fastlinkdi",
    available: 16,
    bus: "fastlink",
    ioType: DigitalIn,
    label: "Fastlink DI",
    reserved: 16,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "DI1", "DI2", "DI3", "DI4", "DI5", "DI6", "DI7", "DI8", "NUL", "NUL",
        "DI9", "DI10", "DI11", "DI12", "DI13", "DI14", "DI15", "DI16", "24V", "NUL"
    ]
}

export const FastlinkDOKart: SimpleKaartType = {
    metaId: "fastlinkdo",
    available: 16,
    bus: "fastlink",
    ioType: DigitalOut,
    label: "Fastlink DO",
    reserved: 16,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "DO1", "DO2", "DO3", "DO4", "DO5", "DO6", "DO7", "DO8", "24V", "NUL",
        "DO9", "DO10", "DO11", "DO12", "DO13", "DO14", "DO15", "DO16", "24V", "NUL"
    ]
}

export const FastlinkROKart: SimpleKaartType = {
    metaId: "fastlinkRO",
    available: 16,
    bus: "fastlink",
    ioType: DigitalOut,
    label: "Fastlink RO",
    reserved: 16,
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: [
        "C1-8",
        "DO1", "DO2", "DO3", "DO4", "DO5", "DO6", "DO7", "DO8", "C9-16",
        "DO9", "DO10", "DO11", "DO12", "DO13", "DO14", "DO15", "DO16", "24V", "NUL"
    ]
}
export const FastLinkCombi: CombiKaartType = {
    metaId: "fastlinkcombi",
    bus: "fastlink",
    karten: [{
        metaId: "fl_combi_do",
        ioType: DigitalOut,
        available: 8,
        bus: "fastlink",
        label: "Combi DO",
        reserved: 8,
        takesRackSpace: false,
        hdwLayout: [
            "DO1", "DO2", "DO3", "DO4", "DO5", "DO6", "DO7", "DO8", "NUL", "NUL"
        ]
    },
    {
        metaId: "fl_combi_ai",
        ioType: AnalogIn,
        available: 4,
        reserved: 16,
        bus: "fastlink",
        label: "Combi AI",
        takesRackSpace: false,
        hdwLayout: [
            "AI1", "AI2", "0VAN", "AI3", "AI4", "NUL",
        ]
    }, {
        metaId: "fl_combi_di",
        ioType: DigitalIn,
        available: 2,
        bus: "fastlink",
        reserved: 8,
        label: "Combi DI",
        takesRackSpace: false,
        hdwLayout: [
            "DI1", "DI2", "24V=", "NUL",
        ]
    }],
    label: "Fastlink Combi",
    maxDipSwitchBits: 6,
    takesRackSpace: true,
    hdwLayout: []
}

export const SC900IO: CombiKaartType = {
    metaId: "scx_900",
    bus: "scx",
    karten: [{
        metaId: "scx_900_di",
        ioType: DigitalIn,
        available: 16,
        bus: "scx",
        reserved: 64,
        label: "DI",
        takesRackSpace: false,
        hdwLayout: [
            "+5V", "0V", "24Vm", "24V=", "NUL", "Lin-", "Lin+", "Lout", "+12V", "NUL",
            "", "NUL", "", "NC", "COM", "NO", "NUL", "NUL", "NUL", "NUL",
            "24Vm", "24Vm", "24Vm", "24Vm", "", "B", "A", "GND", "24V", "NUL",
            "DI8", "DI7", "DI6", "DI5", "DI4", "DI3", "DI2", "DI1", "NUL", "NUL",
            "DI16", "DI15", "DI14", "DI13", "DI12", "DI11", "DI10", "DI9", "NUL", "NUL"
        ]
    },
    {
        metaId: "scx_900_do",
        ioType: DigitalOut,
        available: 48,
        bus: "scx",
        label: "DO",
        reserved: 64,
        takesRackSpace: false,
        hdwLayout: [
            "DO1", "DO2", "DO3", "DO4", "DO5", "DO6", "DO7", "DO8", "DO09", "DO10",
            "DO11", "DO12", "DO13", "DO14", "DO15", "DO16", "DO17", "DO18", "DO19", "DO20",
            "DO21", "DO22", "DO23", "DO24", "DO25", "DO26", "DO27", "DO28", "DO29", "DO30",
            "DO31", "DO32", "DO33", "DO34", "DO35", "DO36", "DO37", "DO38", "DO39", "DO40",
            "DO41", "DO42", "DO43", "DO44", "DO45", "DO46", "DO47", "DO48", "NUL", "NUL"
        ]
    },
    {
        metaId: "scx_900_ai",
        ioType: AnalogIn,
        available: 48,
        reserved: 64,
        bus: "scx",
        label: "AI",
        takesRackSpace: false,
        hdwLayout: [
            "AI1", "AI2", "0VAN", "AI3", "AI4", "AI5", "AI6", "0VAN", "AI7", "AI8",
            "AI9", "AI10", "0VAN", "AI11", "AI12", "AI13", "AI14", "0VAN", "AI15", "AI16",
            "AI17", "AI18", "0VAN", "AI19", "AI20", "AI21", "AI22", "0VAN", "AI23", "AI24",
            "AI25", "AI26", "0VAN", "AI27", "AI28", "AI29", "AI30", "0VAN", "AI31", "AI32",
            "AI33", "AI34", "0VAN", "AI35", "AI36", "AI37", "AI38", "0VAN", "AI39", "AI40",
            "AI41", "AI42", "0VAN", "AI43", "AI44", "AI45", "AI46", "0VAN", "AI47", "AI48"
        ]
    }],
    label: "SC9x0 I/O",
    maxDipSwitchBits: 1,
    takesRackSpace: true,
    hdwLayout: []
}

export const AVAkart: SysteemKaartType = {
    metaId: "scx_ava",
    label: "AVA",
    bus: "scx",
    isExtension: false,
    takesRackSpace: true,
    noDipSwitch: true,
    hdwLayout: [
        "45VAC", "45VAC", "10VAC", "10VAC", "24VAC", "24VAC", "+12V", "0V", "0V", "+5VOC",
        "+5VOC", "+24Vm", "+24V=", "PE", "Wuit", "Win", "", "", "", "",
        "", "", "", "SHLD", "B", "A", "GND", "24V", "L-IN", "L+IN",
        "L UIT", "", "GND", "", "NO", "COMM", "NC", "", "GND", ""
    ]
}
export const EmptySCXKart: SysteemKaartType = {
    metaId: "scx_empty",
    label: "Empty",
    bus: "scx",
    isExtension: false,
    takesRackSpace: true,
    noDipSwitch: true,
    hdwLayout: []
}

export const RackXTender: SysteemKaartType = {
    metaId: "scx_xt",
    label: "Rack XTender",
    bus: "scx",
    isExtension: true,
    takesRackSpace: true,
    hdwLayout: [
        "24VAC", "24VAC", "PE", "+24V=", "+24V=", "NUL", "+24Vm", "+24Vm", "NUL", "NUL",
        "B", "A", "GND", "24V", "5V", "5V", "NUL", "NUL", "+13V", "NUL"
    ]
}

export const FaskLinkXTender: SysteemKaartType = {
    metaId: "fastlink_xt",
    label: "XTender",
    bus: "fastlink",
    isExtension: true,
    maxDipSwitchBits: 4,
    takesRackSpace: true,
    hdwLayout: ["28V~", "28V~", "PE", "24Vm", "24Vm", "24V=", "24V=", "NUL", "NUL", "+5V",
        "NUL", "SHLD", "B", "A", "GND", "24V", "B", "A", "0V", "24V"
    ]
}


export const SCX: MainboardType = {
    label: "SCX",
    metaId: "scx",
    busTypes: ['scx'],
    racks: [
        {
            bus: 'scx',
            slots: 10,
            label: 'Rack',
            karten: [{
                metaId: "scx_ava",
                label: "AVA",
                bus: "scx",
                isExtension: false,
                takesRackSpace: true,
                noDipSwitch: true,
                hdwLayout: [
                    "45VAC", "45VAC", "10VAC", "10VAC", "24VAC", "24VAC", "+12V", "0V", "0V", "+5VOC",
                    "+5VOC", "+24Vm", "+24V=", "PE", "Wuit", "Win", "", "", "", "",
                    "", "", "", "SHLD", "B", "A", "GND", "24V", "L-IN", "L+IN",
                    "L UIT", "", "GND", "", "NO", "COMM", "NC", "", "GND", ""
                ]
            }]
        }
    ],
    karten: [],
    kaartTypes: [SCXAIKart, SCXAOKart, SCXDIKart, SCXDOKart, SCXROKart, AVAkart, RackXTender, EmptySCXKart]
}

export const SC900: MainboardType = {
    label: "SC900/SC950",
    metaId: "sc900",
    busTypes: ['scx', 'fastlink'],
    racks: [{
        bus: "scx",
        slots: 2,
        label: "Hoofdcomputer 60Polig",
        hideNumber: true,
        karten: [
        ]
    }, {
        bus: "fastlink",
        slots: 4,
        label: "Hoofdcomputer FastLink",
        hideNumber: true,
        karten: [
            {
                metaId: "sc900_main_fastlink_xt",
                label: "Main FastLink XTender",
                bus: "fastlink",
                isExtension: true,
                takesRackSpace: false,
                hdwLayout: []
            },
        ]
    }],
    karten: [],
    offsets: {
        fastlink: {
            AI: 128,
            AO: 0,
            DI: 128,
            DO: 128
        }
    },
    kaartTypes: [FastLinkAIKart,
        FastlinkAOKart, FastlinkDIKart, FastlinkDOKart, FaskLinkXTender, FastLinkCombi, FastlinkROKart, SC900IO]
}

export const SC800: MainboardType = {
    label: "SC800/SC850",
    metaId: "sc800",
    busTypes: ['fastlink'],
    racks: [{
        bus: "fastlink",
        slots: 3,
        label: "Hoofdcomputer",
        hideNumber: true,
        karten: [
            {
                metaId: "sc800_main_xt",
                label: "Main FastLink XTender",
                bus: "fastlink",
                isExtension: true,
                takesRackSpace: false,
                hdwLayout: []
            },
        ]
    }],
    karten: [
        {
            metaId: "sc800_main_di",
            bus: "fastlink",
            ioType: DigitalIn,
            available: 8,
            reserved: 8,
            label: "MB DI",
            takesRackSpace: false,
            hdwLayout: ["DI1", "DI2", "DI3", "DI4", "DI5", "DI6", "DI7", "DI8", "NUL", "NUL"]
        },
        {
            metaId: "sc800_main_do",
            bus: "fastlink",
            ioType: DigitalOut,
            available: 16,
            reserved: 16,
            label: "MB DO",
            takesRackSpace: false,
            hdwLayout: [
                "DO1", "DO2", "DO3", "DO4", "DO5", "DO6", "DO7", "DO8", "NUL", "NUL",
                "DO9", "DO10", "DO11", "DO12", "DO13", "DO14", "DO15", "DO16", "NUL", "NUL"]
        },
        {
            metaId: "sc800_main_ai",
            bus: "fastlink",
            ioType: AnalogIn,
            available: 16,
            reserved: 16,
            label: "MB AI",
            takesRackSpace: false,
            hdwLayout: [
                "AI1", "AI2", "0VAN",
                "AI3", "AI4", "AI5", "AI6", "0VAN",
                "AI7", "AI8", "AI9", "AI10", "0VAN",
                "AI11", "AI12", "AI13", "AI14", "0VAN",
                "AI15", "AI16"
            ]
        }

    ],
    kaartTypes: [FastLinkAIKart,
        FastlinkAOKart, FastlinkDIKart, FastlinkDOKart, FaskLinkXTender, FastLinkCombi, FastlinkROKart]
}

export const SC810: MainboardType = {
    label: "SC810/SC860",
    metaId: "sc810",
    busTypes: ['fastlink'],
    racks: [{
        bus: "fastlink",
        slots: 4,
        label: "Hoofdcomputer",
        hideNumber: true,
        karten: [
            {
                metaId: "sc810_main_xt",
                label: "XTender",
                bus: "fastlink",
                isExtension: true,
                takesRackSpace: false,
                hdwLayout: []
            },
        ]
    }],
    karten: [
        {
            metaId: "sc810_main_di",
            bus: "fastlink",
            ioType: DigitalIn,
            available: 8,
            reserved: 8,
            label: "MB DI",
            takesRackSpace: false,
            hdwLayout: ["DI1", "DI2", "DI3", "DI4", "DI5", "DI6", "DI7", "DI8", "NUL", "NUL"]
        },
        {
            metaId: "sc810_main_do",
            bus: "fastlink",
            ioType: DigitalOut,
            available: 16,
            reserved: 16,
            label: "MB DO",
            takesRackSpace: false,
            hdwLayout: [
                "DO1", "DO2", "DO3", "DO4", "DO5", "DO6", "DO7", "DO8", "NUL", "NUL",
                "DO9", "DO10", "DO11", "DO12", "DO13", "DO14", "DO15", "DO16", "NUL", "NUL"]
        },
        {
            metaId: "sc810_main_ai",
            bus: "fastlink",
            ioType: AnalogIn,
            available: 16,
            reserved: 16,
            label: "MB AI",
            takesRackSpace: false,
            hdwLayout: [
                "AI1", "AI2", "0VAN",
                "AI3", "AI4", "AI5", "AI6", "0VAN",
                "AI7", "AI8", "AI9", "AI10", "0VAN",
                "AI11", "AI12", "AI13", "AI14", "0VAN",
                "AI15", "AI16"
            ]
        }

    ],
    kaartTypes: [FastLinkAIKart,
        FastlinkAOKart, FastlinkDIKart, FastlinkDOKart, FaskLinkXTender, FastLinkCombi, FastlinkROKart]
}
export class HdwMeta {
    public mainBoards = [SC800, SC810, SC900, SCX];
    public racks = [SCXRack, FastLinkRack];
    public kaarten = [SCXAIKart, SCXAOKart, SCXDIKart, SCXDOKart, SCXROKart, FastLinkAIKart,
        FastlinkAOKart, FastlinkDIKart, FastlinkDOKart, FastlinkROKart, AVAkart, RackXTender, FaskLinkXTender, FastLinkCombi, SC900IO, EmptySCXKart];

    public getRackByBus(bus: string): HdwRackType[] {
        return this.racks.filter(r => r.bus == bus);
    }

    public getKaartenByBus(bus: string): KaartType[] {
        return this.kaarten.filter(k => k.bus == bus);
    }
    public getMBByIdOrLabel(metaId: string | undefined, label: string) {
        for (let m of this.mainBoards) {
            if ((m.metaId == metaId) || ((m.label == label) && metaId == undefined)) {
                return m;
            }
        }
        return undefined;
    }
    public getKartByIdOrLabel(metaId: string | undefined, label: string) {
        let ret = this.findKaartInArray(this.kaarten, metaId, label);
        if (ret != undefined) {
            return ret;
        }
        for (let r of this.racks) {
            ret = this.findKaartInArray(r.karten, metaId, label);
            if (ret != undefined) {
                return ret;
            }
        }
        for (let m of this.mainBoards) {
            ret = this.findKaartInArray(m.karten, metaId, label);
            if (ret != undefined) {
                return ret;
            }
        }
        return undefined;
    }

    private findKaartInArray(karten: (SimpleKaartType | CombiKaartType | SysteemKaartType)[], metaId: string | undefined, label: string) {
        for (let k of karten) {
            if ((k.metaId == metaId) || ((k.label == label) && metaId == undefined)) {
                return k;
            }
            if (isCombiKaart(k)) {
                for (let kc of k.karten) {
                    if ((kc.metaId == metaId) || ((kc.label == label) && metaId == undefined)) {
                        return kc;
                    }
                }
            }
        }

    }
}
